import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../app/store";
import {
  selectAuthenticated,
  selectToken,
  setAuthtenticated,
  setToken,
} from "../../features/Dashboard/Slices/userSlice";
import { getParametros } from "../../features/Dashboard/AsyncThunks/parametros/getParametros";
import PageLoader from "../../components/reusable/PageLoader/PageLoader";
import { isFulfilled } from "@reduxjs/toolkit";
import { validateToken } from "../../features/Dashboard/AsyncThunks/estadoGeneral/validateToken";

function InitialPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const authenticated = useSelector(selectAuthenticated);

  const logout = () => {
    localStorage.clear();
    dispatch(setToken(null));
    dispatch(setAuthtenticated(false));
    navigate("/login");
  };

  const login = (token: string) => {
    dispatch(setAuthtenticated(true));
    dispatch(setToken(token));
    navigate("/home");
  };

  const checkToken = async (token: string) => {
    try {
      if (authenticated) {
        dispatch(setAuthtenticated(false));
      }
      const result = await dispatch(validateToken(token));
      if (isFulfilled(result)) {
        console.log("Token is valid, redirecting to home...");
        login(token);
      } else {
        console.log("Token is invalid, logging out...");
        logout();
      }
    } catch (error) {
      console.error("Error validando token:", error);
      logout();
    }
  };

  useEffect(() => {
    const initializeApp = async () => {
      const storedToken = localStorage.getItem("token");

      if (!storedToken) {
        console.log("No token found, redirecting to login...");
        navigate("/login");
        return;
      } else {
        console.log("Token found, setting token...");
        await checkToken(storedToken);
      }
    };

    initializeApp();
  }, []);

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-white">
      <PageLoader />
    </div>
  );
}

export default InitialPage;
